import React, { useState } from "react";
import "./EmiCalculator.css";

const EmiCalculator = () => {
  const [tab, setTab] = useState("home");
  const [amount, setAmount] = useState("");
  const [rate, setRate] = useState("");
  const [tenure, setTenure] = useState("");
  const [emiDetails, setEmiDetails] = useState(null);
  
   const getButtonLink = () => {
  switch(tab) {
    case "business":
      return "/business-loan";
    case "home":
      return "/home-loan";
    case "personal":
      return "/personal-loan";
    default:
      return "/loans";
  }
};


  // Format numbers in Indian system
  const formatIndian = (num) =>
    new Intl.NumberFormat("en-IN").format(num);

  // EMI Formula + Breakdown
  const calculateEMI = () => {
    if (!amount || !rate || !tenure) return;

    let P = parseFloat(amount);
    let R = parseFloat(rate) / 12 / 100;
    let N = parseInt(tenure) * 12; // years to months

    let emiVal = (P * R * Math.pow(1 + R, N)) / (Math.pow(1 + R, N) - 1);
    emiVal = Math.round(emiVal);

    let totalPayable = emiVal * N;
    let interestPayable = totalPayable - P;

    setEmiDetails({
      emi: emiVal,
      principal: P,
      interest: Math.round(interestPayable),
      total: Math.round(totalPayable),
    });
  };

  return (
    <div>
      {/* Tabs */}
      <div className="tab-buttons">
        <button onClick={() => setTab("home")} className={tab==="home" ? "active" : ""}>🏠  Home</button>
        <button onClick={() => setTab("personal")} className={tab==="personal" ? "active" : ""}>👤 Personal</button>
        <button onClick={() => setTab("business")} className={tab==="business" ? "active" : ""}>💼 Business</button>
      </div>

      {/* Form */}
      <div className="emi-form">
        <label>Loan Amount (₹)</label>
        <input
          type="number"
          value={amount}
          onChange={(e) => setAmount(e.target.value)}
        />

        <label>Interest Rate (%)</label>
        <input
          type="number"
          value={rate}
          onChange={(e) => setRate(e.target.value)}
        />

        <label>Tenure (Years)</label>
        <input
          type="number"
          value={tenure}
          onChange={(e) => setTenure(e.target.value)}
        />

        <button onClick={calculateEMI}>Calculate</button>

        {emiDetails && (
          <div className="emi-result">
            <h3>Monthly EMI</h3>
            <p className="highlight">₹{formatIndian(emiDetails.emi)}</p>

            <div className="emi-breakdown">
              <div>
                <strong>Principal Amount</strong>
                <p>₹{formatIndian(emiDetails.principal)}</p>
              </div>
              <div>
                <strong>Interest Payable</strong>
                <p>₹{formatIndian(emiDetails.interest)}</p>
              </div>
              <div>
                <strong>Total Amount Payable</strong>
                <p>₹{formatIndian(emiDetails.total)}</p>
              </div>
            </div>

             <button
    onClick={() => window.location.href = getButtonLink()}
    className="explore-btn">
      
    {tab === "business" 
      ? "Explore Business Loan" 
      : tab === "home" 
        ? "Explore Home Loan" 
        : tab === "personal" 
          ? "Explore Personal Loan" 
          : "Explore More"}
  </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default EmiCalculator;
